exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".miniFilter__selector___2pS0H{float:none;display:block;padding:0;margin:0 0 15px;max-width:100%;position:relative;z-index:inherit}.miniFilter__filterWrapper___2jOmD{height:35px}.miniFilter__filterTitle___ia-p1{text-align:left;width:100%;height:52px;border:1px solid #bdc3d1;outline:none;font-size:calc(12px + 2 * ((100vw - 420px) / 860));padding:15px 22px 15px 15px;font-style:normal;border-radius:0;background-color:#fcfcfd;box-sizing:border-box;position:relative}.miniFilter__filterTitle___ia-p1 svg{position:absolute;margin:0;font-size:20px;font-weight:400;line-height:1;color:#fff;text-align:center;background-color:#004f5c;border:1px solid #004f5c;border-radius:0;height:20px;width:52px;top:-1px;right:0;cursor:pointer;box-sizing:content-box;padding:15px 0}.miniFilter__dropdown___9Q_sE .miniFilter__options___1-tOL{width:100%;margin-left:0;z-index:2}.miniFilter__filterButton___2RigT{padding:10px 0 0 14px;font-size:12px}.miniFilter__filterButton___2RigT div{height:36px}@media screen and (min-width:1280px){.miniFilter__filterTitle___ia-p1{font-size:14px}}@media screen and (max-width:420px){.miniFilter__filterTitle___ia-p1{font-size:12px}}", ""]);

// exports
exports.locals = {
	"selector": "miniFilter__selector___2pS0H",
	"filterWrapper": "miniFilter__filterWrapper___2jOmD",
	"filterTitle": "miniFilter__filterTitle___ia-p1",
	"dropdown": "miniFilter__dropdown___9Q_sE",
	"options": "miniFilter__options___1-tOL",
	"filterButton": "miniFilter__filterButton___2RigT"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/postcss-loader!./src/client/components/MiniFundFinder/overrides/miniFilter.pcss
// module id = 899
// module chunks = 0